import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10 4c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6zm0-1c-3.85 0-7 3.15-7 7s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7zm-.459 3h.917c.291 0 .521.249.496.539L10.499 11h-1l-.455-4.461A.498.498 0 0 1 9.54 6zM10 14c-.571 0-1-.429-1-1s.429-1 1-1 1 .429 1 1-.429 1-1 1z',
  ],
  height: 20,
  width: 20,
});
